import React from "react";
import "./BrandLogos.css";

import logo1 from "../images/logo22.png";
import logo2 from "../images/logo23.png";
import logo3 from "../images/logo24.png";
import logo4 from "../images/logo25.png";
import logo5 from "../images/logo26.png";
import logo6 from "../images/logo27.png";
import logo7 from "../images/logo28.png";
import logo8 from "../images/logo29.png";
import logo9 from "../images/logo30.png";
import logo10 from "../images/logo31.png";
import logo11 from "../images/logo32.png";
import logo12 from "../images/logo33.png";
import logo13 from "../images/logo34.png";
import logo14 from "../images/logo35.png";
import logo15 from "../images/logo36.png";
import logo16 from "../images/logo37.png";
import logo17 from "../images/logo38.png";
import logo18 from "../images/logo39.png";
import logo19 from "../images/logo40.png";
import logo20 from "../images/logo41.png";
import logo21 from "../images/logo42.png";
import logo22 from "../images/logo43.png";
import logo23 from "../images/logo44.png";
import logo24 from "../images/logo45.png";
import logo25 from "../images/logo46.png";
import logo26 from "../images/logo47.png";
import logo27 from "../images/logo48.png";


const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10, logo11, logo12, logo13, logo14, logo15, logo16, logo17, logo18, logo19, logo20, logo21, logo22, logo23, logo24, logo25, logo26, logo27, ];

const BrandLogos = () => {
  return (
    <section className="brand-section">
      <div className="brand-header">
        <span>Customer Base
        </span>
      </div>

      <div className="brand-slider">
        <div className="brand-track">
          {[...logos, ...logos].map((logo, index) => (
            <div className="brand-item" key={index}>
              <img src={logo} alt={`Brand ${index}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandLogos;